import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["initialTask", "taskTemplateId", "onSlideBack"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TemplatedEdit } from './Edit';
import { TemplatedNew } from './New';
import { jsx as _jsx } from "react/jsx-runtime";
export var TemplatedIntake = function TemplatedIntake(_ref) {
  var initialTask = _ref.initialTask,
      taskTemplateId = _ref.taskTemplateId,
      onSlideBack = _ref.onSlideBack,
      props = _objectWithoutProperties(_ref, _excluded);

  if (initialTask) {
    return /*#__PURE__*/_jsx(TemplatedEdit, _objectSpread(_objectSpread({}, props), {}, {
      initialTask: initialTask
    }));
  }

  if (onSlideBack) {
    return /*#__PURE__*/_jsx(TemplatedNew, _objectSpread(_objectSpread({}, props), {}, {
      taskTemplateId: taskTemplateId,
      onSlideBack: onSlideBack
    }));
  }

  throw new Error('Invalid todo intake state');
};